/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/additionalPoint/selector/selector.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import10 from '../../../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import11 from '@angular/core/src/linker/view_container';
import * as import12 from '@angular/core/src/linker/element_ref';
import * as import13 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import14 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import15 from '@angular/core/src/linker/query_list';
import * as import16 from '../../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import17 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import18 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import19 from '@ngx-translate/core/src/translate.pipe';
import * as import20 from '@angular/core/src/linker/template_ref';
import * as import21 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import22 from '@ngx-translate/core/src/translate.service';
import * as import23 from '@angular/common/src/directives/ng_for';
import * as import24 from '@angular/forms/src/directives/control_value_accessor';
import * as import25 from '@angular/forms/src/directives/ng_model';
import * as import26 from '@angular/forms/src/directives/ng_control';
import * as import27 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_SelectorComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SelectorComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  subscription0:any;
  subscription1:any;
  constructor() {
    this._changed = false;
    this.context = new import0.SelectorComponent();
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._expr_0 = currValue;
    }
  }
  check_invalid(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.invalid = currValue;
      this._expr_1 = currValue;
    }
  }
  check_invalidText(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.invalidText = currValue;
      this._expr_2 = currValue;
    }
  }
  check_disabled(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.disabled = currValue;
      this._expr_3 = currValue;
    }
  }
  check_list(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.list = currValue;
      this._expr_4 = currValue;
    }
  }
  check_disableDefault(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.disableDefault = currValue;
      this._expr_5 = currValue;
    }
  }
  check_model(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.model = currValue;
      this._expr_6 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.onChange.subscribe(_eventHandler.bind(view,'onChange'))); }
    if (emit1) { (this.subscription1 = this.context.modelChange.subscribe(_eventHandler.bind(view,'modelChange'))); }
  }
}
var renderType_SelectorComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SelectorComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SelectorComponent>;
  _SelectorComponent_0_3:Wrapper_SelectorComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SelectorComponent_Host0,renderType_SelectorComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'selector-item',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SelectorComponent0(this.viewUtils,this,0,this._el_0);
    this._SelectorComponent_0_3 = new Wrapper_SelectorComponent();
    this.compView_0.create(this._SelectorComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._SelectorComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SelectorComponent) && (0 === requestNodeIndex))) { return this._SelectorComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SelectorComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SelectorComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SelectorComponentNgFactory:import8.ComponentFactory<import0.SelectorComponent> = new import8.ComponentFactory<import0.SelectorComponent>('selector-item',View_SelectorComponent_Host0,import0.SelectorComponent);
const styles_SelectorComponent:any[] = ([] as any[]);
class View_SelectorComponent1 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import9.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import10.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import11.ViewContainer) {
    super(View_SelectorComponent1,renderType_SelectorComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSelectOption_0_3 = new import9.Wrapper_NgSelectOption(new import12.ElementRef(this._el_0),this.renderer,(<View_SelectorComponent0>this.parentView)._SelectControlValueAccessor_4_3.context);
    this._NgSelectMultipleOption_0_4 = new import10.Wrapper_NgSelectMultipleOption(new import12.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import13.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import14.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit.id;
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit.id;
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit.value,'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_SelectorComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SelectorComponent,{});
export class View_SelectorComponent0 extends import2.AppView<import0.SelectorComponent> {
  _viewQuery_selectorItem_0:import15.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _SelectControlValueAccessor_4_3:import9.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_4_4:any[];
  _NgModel_4_5:import16.Wrapper_NgModel;
  _NgControl_4_6:any;
  _NgControlStatus_4_7:import17.Wrapper_NgControlStatus;
  _text_5:any;
  _el_6:any;
  _NgSelectOption_6_3:import9.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_6_4:import10.Wrapper_NgSelectMultipleOption;
  _text_7:any;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import11.ViewContainer;
  _TemplateRef_9_5:any;
  _NgFor_9_6:import18.Wrapper_NgFor;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  /*private*/ _expr_25:any;
  _pipe_translate_0:import19.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SelectorComponent0,renderType_SelectorComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_25 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_selectorItem_0 = new import15.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-select -md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'select',new import3.InlineArray4(4,'class','select-tag','id','eva-select'),(null as any));
    this._SelectControlValueAccessor_4_3 = new import9.Wrapper_SelectControlValueAccessor(this.renderer,new import12.ElementRef(this._el_4));
    this._NG_VALUE_ACCESSOR_4_4 = [this._SelectControlValueAccessor_4_3.context];
    this._NgModel_4_5 = new import16.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_4_4);
    this._NgControl_4_6 = this._NgModel_4_5.context;
    this._NgControlStatus_4_7 = new import17.Wrapper_NgControlStatus(this._NgControl_4_6);
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'option',new import3.InlineArray4(4,'selected','','value','0'),(null as any));
    this._NgSelectOption_6_3 = new import9.Wrapper_NgSelectOption(new import12.ElementRef(this._el_6),this.renderer,this._SelectControlValueAccessor_4_3.context);
    this._NgSelectMultipleOption_6_4 = new import10.Wrapper_NgSelectMultipleOption(new import12.ElementRef(this._el_6),this.renderer,(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._vc_9 = new import11.ViewContainer(9,4,this,this._anchor_9);
    this._TemplateRef_9_5 = new import20.TemplateRef_(this,9,this._anchor_9);
    this._NgFor_9_6 = new import18.Wrapper_NgFor(this._vc_9.vcRef,this._TemplateRef_9_5,this.parentView.injectorGet(import21.IterableDiffers,this.parentIndex),this.ref);
    this._text_10 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_13 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray8(6,'ngModelChange',(null as any),'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_4));
    this._NgModel_4_5.subscribe(this,this.eventHandler(this.handleEvent_4),true);
    this._pipe_translate_0 = new import19.TranslatePipe(this.parentView.injectorGet(import22.TranslateService,this.parentIndex),this.ref);
    this._viewQuery_selectorItem_0.reset([new import12.ElementRef(this._el_4)]);
    this.context.child = this._viewQuery_selectorItem_0.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import13.NgSelectOption) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._NgSelectOption_6_3.context; }
    if (((token === import14.NgSelectMultipleOption) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._NgSelectMultipleOption_6_4.context; }
    if (((token === import20.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import23.NgFor) && (9 === requestNodeIndex))) { return this._NgFor_9_6.context; }
    if (((token === import13.SelectControlValueAccessor) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._SelectControlValueAccessor_4_3.context; }
    if (((token === import24.NG_VALUE_ACCESSOR) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NG_VALUE_ACCESSOR_4_4; }
    if (((token === import25.NgModel) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgModel_4_5.context; }
    if (((token === import26.NgControl) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgControl_4_6; }
    if (((token === import27.NgControlStatus) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgControlStatus_4_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this._SelectControlValueAccessor_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_4_1_0:any = this.context.modelValue;
    this._NgModel_4_5.check_model(currVal_4_1_0,throwOnChange,false);
    this._NgModel_4_5.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatus_4_7.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_6_0_0:any = '0';
    this._NgSelectOption_6_3.check_value(currVal_6_0_0,throwOnChange,false);
    this._NgSelectOption_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_6_1_0:any = '0';
    this._NgSelectMultipleOption_6_4.check_value(currVal_6_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_6_4.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_9_0_0:any = this.context.list;
    this._NgFor_9_6.check_ngForOf(currVal_9_0_0,throwOnChange,false);
    this._NgFor_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    this._NgControlStatus_4_7.checkHost(this,this,this._el_4,throwOnChange);
    valUnwrapper.reset();
    const currVal_25:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.SELECT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_25,currVal_25))) {
      this.renderer.setText(this._text_7,currVal_25);
      this._expr_25 = currVal_25;
    }
  }
  destroyInternal():void {
    this._vc_9.destroyNestedViews();
    this._NgSelectOption_6_3.ngOnDestroy();
    this._NgSelectMultipleOption_6_4.ngOnDestroy();
    this._NgModel_4_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 9)) { return new View_SelectorComponent1(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_4_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.context.modelValue = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.context.changeEvent()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/additionalPoint/selector/selector.component.ngfactory.ts